module.exports = __webpack_public_path__ + "static/media/ketaki_jadhav.a85ccbcd.jpg";